<template lang="pug">
div
	Nueva(v-if="crear", @cerrar="crear = null")
	router-view
</template>

<script>
import Nueva from './components/nueva'

export default {
	components: {
		Nueva
	},
	data () {
		return {
			crear: null
		}
	},
	created () {
		const menu = [
			{
				'icono': 'fa fa-list',
				'nombre': 'Tablero',
				activo: true,
				callback: (a) => {
					this.$store.commit('top/setMenuActivo', a)
					this.$router.push('/main/solicitudes')
				}
			},
			{
				'icono': 'fa fa-search',
				'nombre': 'Buscador',
				activo: false,
				callback: (a) => {
					this.$store.commit('top/setMenuActivo', a)
					this.$router.push('/main/solicitudes/buscador')
				}
			}]

		this.$store.commit('top/setMenu', menu)
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/solicitudes/vue/Main.vue